// extracted by mini-css-extract-plugin
export default {"settings":"UoShHZp6wx1OjTt4nu7A"};